

































































































import { defineComponent } from '@vue/composition-api'
import type { InsuranceInfoRes } from 'api/api-type'
import NumScroll from './num-scroll.vue'
import Panel from './panel.vue'
import SvgCircle from './svg-circle.vue'
import {
  DRIVER_GRADE,
  KUAICHE_LEVEl_MAP,
  KUAICHE_TEXT_MAP,
  ZHUANCHE_LEVEL_MAP,
  ZHUANCHE_TEXT_MAP,
  ZHUANCHE_LEVEL_COLOR,
  KUAICHE_LEVEL_COLOR,
  ZHUANCHE_LEVEL_GREY_ICON,
  ZHUANCHE_LEVEL_LIGHT_ICON,
  KUAICHE_LEVEL_GREY_ICON,
  KUAICHE_LEVEL_LIGHT_ICON
} from '@/common/biz/constants'

export default defineComponent({
  name: 'quest',
  props: {
    isDriverDay: {
      type: Boolean,
      default: false
    },
    driverLevel: {
      type: Number,
      default: 0
    },
    driverGrade: {
      type: [String, Number],
      default: '7'
    },
    quest: {
      type: Object,
      default: () => {
        return {} as InsuranceInfoRes['quest']
      }
    },
    showTop: {
      type: Boolean,
      default: false
    },
    money: {
      type: Number,
      default: 0
    }
  },
  computed: {
    tsh() {
      const quest = this.quest as unknown as InsuranceInfoRes['quest']
      return quest.quest_content.filter(item => {
        return item.quest_type === 'service_time_sum'
      })[0]
    },
    totalTshTime() {
      if (!this.tsh) return 0
      // eslint-disable-next-line
      const tsh = this.tsh as { quest_data: number[] }
      return tsh.quest_data.reduce((res, item) => {
        return res + item
      }, 0)
    },
    online() {
      const quest = this.quest as unknown as InsuranceInfoRes['quest']
      return quest.quest_content.filter(item => {
        return item.quest_type === 'online_time_series_large'
      })[0]
    },
    grade() {
      const quest = this.quest as unknown as InsuranceInfoRes['quest']
      return quest.quest_content.filter(item => {
        return item.quest_type === 'driver_grade'
      })[0]
    },
    isZhuanche() {
      const driverGrade = this.driverGrade as unknown as string
      return driverGrade === DRIVER_GRADE.zhuanche
    },
    levelList() {
      const level = this.driverLevel as unknown as number
      const isZhuanche = this.isZhuanche as unknown as boolean
      let list:number[] = []
      if (isZhuanche) {
        list = [ZHUANCHE_LEVEL_MAP.authentication, ZHUANCHE_LEVEL_MAP.senior, ZHUANCHE_LEVEL_MAP.outstanding, ZHUANCHE_LEVEL_MAP.specialStar]
      } else {
        list = [1, 2, 3, 4, 5, 6]
      }
      const textMap = isZhuanche ? ZHUANCHE_TEXT_MAP : KUAICHE_TEXT_MAP
      const iconMap = isZhuanche ? ZHUANCHE_LEVEL_LIGHT_ICON : KUAICHE_LEVEL_LIGHT_ICON
      const iconGreyMap = isZhuanche ? ZHUANCHE_LEVEL_GREY_ICON : KUAICHE_LEVEL_GREY_ICON
      const colorMap = isZhuanche ? ZHUANCHE_LEVEL_COLOR : KUAICHE_LEVEL_COLOR
      return list.map((item, index) => {
        const isLight = item <= level
        const nextIsLight = list[index + 1] ? list[index + 1] <= level : isLight
        return {
          level: item,
          levelText: textMap[item],
          light: isLight,
          icon: isLight ? iconMap[item] : iconGreyMap[item],
          left: isLight ? colorMap[item] : colorMap.disabled,
          right: nextIsLight ? colorMap[item] : colorMap.disabled
        }
      })
    },
    lineStyle() {
      const list = this.levelList as Record<'left'|'right', string>[]
      const len = list.length
      const percent = 100 / (len - 1)
      let bgImg = 'background-image: linear-gradient(90deg'
      for (let i = 0; i < len; i++) {
        bgImg = `${bgImg},${list[i].left} ${percent * i}%, ${list[i].right} ${percent * i}%`
      }
      bgImg = bgImg + ')'
      return `color: red; ${bgImg}`
    },
    isAchieve() {
      const level = this.driverLevel as unknown as number
      const isZhuanche = this.isZhuanche as unknown as boolean
      if (isZhuanche) {
        return level >= ZHUANCHE_LEVEL_MAP.senior
      } else {
        return level >= KUAICHE_LEVEl_MAP.four
      }
    },
    month() {
      const now = new Date()
      const nowMonth = now.getMonth() + 1
      if (nowMonth === 1) {
        return [10, 11, 12]
      } else if (nowMonth === 2) {
        return [11, 12, 1]
      } else if (nowMonth === 3) {
        return [12, 1, 2]
      } else {
        return [nowMonth - 3, nowMonth - 2, nowMonth - 1]
      }
    },
    progress() {
      const totalTshTime = this.totalTshTime as number
      const res = totalTshTime / 90
      if (res >= 1) return 1
      else return Math.min(res, 0.95)
    },
    progressText() {
      const progress = this.progress as number
      return Math.floor(progress * 100)
    }
  },
  watch: {
    isZhuanche: {
      handler(newV) {
        this.$nextTick(() => {
          if (!this.$refs.scrollWrapper) return
          if (newV) {
            if (this.driverLevel >= ZHUANCHE_LEVEL_MAP.outstanding) {
              (this.$refs.scrollWrapper as Element).scroll(1000, 0)
            }
          } else {
            const scrollDom = this.$refs.scrollWrapper as Element
            const listWidth = scrollDom.clientWidth * 2.16
            if (this.driverLevel >= KUAICHE_LEVEl_MAP.five) {
              // 5、6
              scrollDom.scroll(1000, 0)
            } else if (this.driverLevel === KUAICHE_LEVEl_MAP.three) {
              scrollDom.scroll((listWidth - 70) / 5, 0)
            } else if (this.driverLevel === KUAICHE_LEVEl_MAP.four) {
              scrollDom.scroll((listWidth - 70) / 2.5, 0)
            }
          }
        })
      },
      immediate: true
    },
    quest: {
      handler(newV) {
        if (newV.title) {
          if (!this.online) return
          setTimeout(() => {
            this.reallyWidth = this.online.quest_data.map(item => {
              return Math.floor(Math.min(item / 150 * 100, 100))
            })
          }, 0)
        }
      },
      immediate: true
    },
    money: {
      handler(newV) {
        this.scrollNum = new Array((newV + '').length).fill(0).join('') as unknown as number
        setTimeout(() => {
          this.scrollNum = newV
        }, 1000)
      },
      immediate: true
    }
  },
  data() {
    return {
      reallyWidth: [0, 0, 0] as number[],
      scrollNum: 0
    }
  },
  components: {
    Panel,
    SvgCircle,
    NumScroll
  }
})
